import type { FaireProductEntity } from "../../entity_types/product";

export const p_m48apzyke8: FaireProductEntity = {
  token: "p_m48apzyke8",
  type: "product",
  name: "Black Obsidian Bats with Stand Natural Crystal Healing",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl:
    "https://cdn.faire.com/fastly/a821149c802d25eb3f2bab475ce15a6e739b7611a0250de15f76dfa6f740073c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/92d4c24abc84b3d492e598d878d416415d6753658e05e693479c0c0a236ab3de.jpeg",
    "https://cdn.faire.com/fastly/fb881a294c25319d59e3791333f99959101eb83354a2906274635018284ea9ce.jpeg",
    "https://cdn.faire.com/fastly/f5a09c967cc200254c680e63da218c8c0235c7bbaebf3cf749ba939a37323e19.jpeg",
    "https://cdn.faire.com/fastly/c7a6a6fd96d738c31a5c5ae14e2f29a709ae4b400edf82da6f99ee4049919444.jpeg",
  ],
  priceDollars: 24.11,
  description:
    "Add something truly unique to your crystal collection with these Natural Black Obsidian Bat carvings. Each piece is beautifully hand-carved with detailed wings and comes with its own display stand, making them perfect for eye-catching retail displays, crystal collections, or themed décor.\n\nBlack Obsidian is widely known as a powerful protection and grounding stone, believed to help absorb negative energy and promote emotional strength. These striking bat carvings make great pieces for metaphysical shops, crystal collectors, Halloween décor, gothic displays, or spiritual gifts.\n\nEach bat measures approximately 11.5 × 6 cm, and when placed on the stand the total display height is about 9 cm, creating an elegant and dramatic presentation.\n\nProduct Details\n\t•\tQuantity: 4 pieces per lot\n\t•\tStone: Natural Black Obsidian\n\t•\tBat Size: approx. 11.5 × 6 cm\n\t•\tHeight with Stand: approx. 9 cm\n\t•\tIncludes 4 display stands\n\t•\tCondition: New\nMinimum order 4 pcs\n\nThese beautifully carved crystal bats are great for resale and perfect for attracting attention in any crystal or metaphysical shop display.\n\nLocal pickup is available in Brooklyn, New York. \n\nStones, stone, crystal, crystals, crystals bulk, crystals wholesale, spiritual, spiritual items, meditation, metaphysical wholesale.",
  tags: [],
  msrpDollars: 48.22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:50.721Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
